import { combineEpics } from 'redux-observable';

import { gotoPortalEpic } from './goto-portal.epic';
import { iovationBlackboxEpic } from './iovation-blackbox.epic';
import { loadConfigEpic } from './load-config.epic';
import { navigateEpic } from './navigate.epic';
import { neuroIdEpic } from './neuro-id.epic';

const appEpic = combineEpics(navigateEpic, gotoPortalEpic, iovationBlackboxEpic, loadConfigEpic, neuroIdEpic);

export { appEpic };
